import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl';
import { push } from 'connected-react-router';
import { trackTransition } from '../../framework/store/FPTI/FPTIActions';
import Button, {BUTTON_STYLE} from '../Button/Button';
import Col from '../VXGrid/Col';
import OneColumnLayout from '../../framework/components/Templates/OneColumnLayout/OneColumnLayout';
import PropTypes from 'prop-types';
import Row from '../VXGrid/Row';
import Waypoint from 'react-waypoint';
import './SharedLandingPage.less';

const LOCALE_PREFIX = 'components/SharedLandingPage/SharedLandingPage';

// we "offset" our waypoint component by this value so the "apply" button
// shows up at the correct time when scrolling
// NOTE: check min-height of .landing-page-header css
const LANDING_PAGE_HEADER_MIN_HEIGHT = 65;

export class SharedLandingPage extends Component {
    static propTypes = {
        Footer: PropTypes.func.isRequired,
        HowItWorks: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
        LandingCarousel: PropTypes.func.isRequired,
        nextPage: PropTypes.string.isRequired,
        onClickContinue: PropTypes.func.isRequired,
        onComponentDidMount: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            showApplyInHeader: false,
            showShadowInHeader: false
        };
    }
    componentDidMount() {
        return this.props.onComponentDidMount();
    }
    handleWaypointEnterShowApply = () => this.setState({ showApplyInHeader: false });
    handleWaypointLeaveShowApply = () => this.setState({ showApplyInHeader: true });
    handleWaypointEnterShowShadow = () => this.setState({ showShadowInHeader: false });
    handleWaypointLeaveShowShadow = () => this.setState({ showShadowInHeader: true });
    handleClickContinue = () => {
        return this.props.onClickContinue(this.props);
    };
    render() {
        const { Footer, HowItWorks, LandingCarousel } = this.props;
        const footer = <Footer showCancelUrl={false} />;
        const button = (
            <Button
                btnStyle={BUTTON_STYLE.PP_PRIMARY}
                data-automation-id="continue"
                onClick={this.handleClickContinue}
            >
                <FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyNow`} />
            </Button>
        );
        let headerClassName = 'landing-page-header';
        if (this.state.showShadowInHeader) {
            headerClassName += ' show-shadow';
        }
        return (
            <OneColumnLayout pageName="SharedLandingPage" overrideFooter={footer}>
                <Waypoint
                    onEnter={this.handleWaypointEnterShowShadow}
                    onLeave={this.handleWaypointLeaveShowShadow}
                />
                <Row className={headerClassName}>
                    <Col xs={6}><div className="ppcredit-logo" /></Col>
                    <Col xs={6}>{this.state.showApplyInHeader && button}</Col>
                </Row>
                <Row>
                    <Col xs={12}><div className="landing-page-header-spacer" /></Col>
                </Row>
                <Row>
                    <Col xs={12}><LandingCarousel /></Col>
                </Row>
                <Row>
                    <Col xs={8} xsOffset={2}>{button}</Col>
                </Row>
                <Waypoint
                    onEnter={this.handleWaypointEnterShowApply}
                    onLeave={this.handleWaypointLeaveShowApply}
                    topOffset={LANDING_PAGE_HEADER_MIN_HEIGHT}
                />
                <Row>
                    <Col xs={12}><HowItWorks /></Col>
                </Row>
            </OneColumnLayout>
        );
    }
}

export const mapStateToProps = state => ({});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        capeLog && capeLog('Loading landing page');
        dispatch(trackTransition('apply_pp_credit_landingpage', 'prepare_apply_pp_credit_landingpage'));
    },
    onClickContinue(props) {
        dispatch(trackTransition('apply_pp_credit_landingpage', 'process_apply_pp_credit_landingpage'));
        dispatch(push(props.nextPage));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SharedLandingPage));
